import Swal from "sweetalert2";
import React, { Component } from "react";
import "../assets/css/bootstrap.css";
import "./global.js";

const tokens = getStorage("token");

const success = () => {
  return Swal.fire({
    icon: "success",
    title: "สำเร็จ",
    text: "การทำรายการสำเร็จแล้ว",
    confirmButtonText: "ตกลง",
    allowEnterKey: true,
    didOpen: () => {
      // เพิ่ม event listener กด Enter (optional)
      const listener = (e) => {
        if (e.key === "Enter") {
          Swal.clickConfirm(); // กดปุ่มตกลงด้วยโปรแกรม
        }
      };
      document.addEventListener("keydown", listener);

      // ลบ event เมื่อ popup ปิด
      Swal.getPopup().addEventListener("closed", () => {
        document.removeEventListener("keydown", listener);
      });
    },
  });
};
const success_url = (url) => {
  return Swal.fire({
    icon: "success",
    title: "สำเร็จ",
    text: "การทำรายการสำเร็จแล้ว",
    confirmButtonText: "ตกลง",
    closeOnClickOutside: false,
    allowEnterKey: true,
    didOpen: () => {
      // เพิ่ม event listener กด Enter (optional)
      const listener = (e) => {
        if (e.key === "Enter") {
          Swal.clickConfirm(); // กดปุ่มตกลงด้วยโปรแกรม
        }
      };
      document.addEventListener("keydown", listener);

      // ลบ event เมื่อ popup ปิด
      Swal.getPopup().addEventListener("closed", () => {
        document.removeEventListener("keydown", listener);
      });
    },
  }).then(() => {
    window.location.href = url;
  });
};
const alert = (icon, title, detail) => {
  return Swal.fire({
    icon: icon,
    title: title,
    text: detail,
    confirmButtonText: "ตกลง",
    allowEnterKey: true,
    didOpen: () => {
      // เพิ่ม event listener กด Enter (optional)
      const listener = (e) => {
        if (e.key === "Enter") {
          Swal.clickConfirm(); // กดปุ่มตกลงด้วยโปรแกรม
        }
      };
      document.addEventListener("keydown", listener);

      // ลบ event เมื่อ popup ปิด
      Swal.getPopup().addEventListener("closed", () => {
        document.removeEventListener("keydown", listener);
      });
    },
  });
};
const alert_url = (icon, title, detail, url) => {
  return Swal.fire({
    icon: icon,
    title: title,
    text: detail,
    confirmButtonText: "ตกลง",
    closeOnClickOutside: false,
    allowEnterKey: true,
    didOpen: () => {
      // เพิ่ม event listener กด Enter (optional)
      const listener = (e) => {
        if (e.key === "Enter") {
          Swal.clickConfirm(); // กดปุ่มตกลงด้วยโปรแกรม
        }
      };
      document.addEventListener("keydown", listener);

      // ลบ event เมื่อ popup ปิด
      Swal.getPopup().addEventListener("closed", () => {
        document.removeEventListener("keydown", listener);
      });
    },
  }).then(() => {
    window.location.href = url;
  });
};
const alert_2 = (url, icon, title, detail, confirm, cancel) => {
    const modals = document.getElementsByClassName("swal2-modal");
    const icons = document.getElementsByClassName("swal2-icon");

    const hasBangIcon = Array.from(icons).some((el) => el.textContent.trim() === "!");
    if (modals.length >= 2 || hasBangIcon) return;
    const hasHTML = (str = "") => /<\/?[a-z][\s\S]*>/i.test(str);
    return Swal.fire({
        icon: icon || "warning",
        title: title || (icon === "success" ? "สำเร็จ" : "แจ้งเตือน"),
        ...(detail
            ? hasHTML(detail)
                ? { html: detail } // ถ้ามี tag → ใช้ html
                : { text: detail } // ถ้าไม่มี tag → ใช้ text
            : {
                  text: icon === "success" ? "การทำรายการสำเร็จแล้ว" : " ",
              }),
        confirmButtonText: confirm || "ตกลง",
        showCancelButton: !!cancel,
        cancelButtonText: cancel || "ยกเลิก",
        background: "#fff",
        color: "#000000",
        confirmButtonColor: "#212529",
    }).then(({ isConfirmed }) => {
        if (url) {
            if (url === "#") window.location.reload();
            else window.location.href = url;
        }
        return isConfirmed;
    });
};
const Logout = async () => {
  removeStorage();
  // return Swal.fire({
  //   icon: "warning",
  //   title: "แจ้งเตือน",
  //   text: "ออกจากระบบ",
  //   confirmButtonText: "ตกลง",
  // }).then(async () => {
  window.location.href = "/login";
  // });
};
const NumberZero = (number, length) => {
  return length ? number.toString().padStart(length, "0") : number.toString().padStart(2, "0");
};
const format_date = (date, format, lacale) => {
  const array_month = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
  const array_full_month = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
  let new_date = new Date(date);
  let full_date = "-";
  let day = new_date.getDate();
  let month = new_date.getMonth();
  let year = new_date.getFullYear();
  let hour = new_date.getHours();
  let minute = new_date.getMinutes();
  let second = new_date.getSeconds();
  if (lacale) {
    if (lacale.toLowerCase() === "en") {
      year = new_date.getFullYear() > 2100 ? new_date.getFullYear() - 543 : new_date.getFullYear();
    } else {
      year = new_date.getFullYear() > 2100 ? new_date.getFullYear() : new_date.getFullYear() + 543;
    }
  } else {
    year = new_date.getFullYear() > 2100 ? new_date.getFullYear() : new_date.getFullYear() + 543;
  }
  if (format) {
    if (format.includes("date")) {
      return new_date;
    }
    format = format.toLowerCase();
    // TIME
    if (format.includes("hh:mm:ss")) {
      format = format.replaceAll("hh:mm:ss", NumberZero(hour) + ":" + NumberZero(minute) + ":" + NumberZero(second));
    } else if (format.includes("hh:mm")) {
      format = format.replaceAll("hh:mm", NumberZero(hour) + ":" + NumberZero(minute));
    }
    // DAY
    if (format.includes("dd")) {
      format = format.replaceAll("dd", NumberZero(day));
    } else {
      format = format.replaceAll("d", day);
    }
    // MONTH
    if (format.includes("mmmm")) {
      format = format.replaceAll("mmmm", array_full_month[month]);
    } else if (format.includes("mmm")) {
      format = format.replaceAll("mmm", array_month[month]);
    } else if (format.includes("mm")) {
      format = format.replaceAll("mm", NumberZero(month + 1));
    } else if (format.includes("m")) {
      format = format.replaceAll("m", month + 1);
    }
    // YEAR
    if (format.includes("yyyy")) {
      format = format.replaceAll("yyyy", NumberZero(year, 4));
    } else if (format.includes("yyy")) {
      format = format.replaceAll("yyy", year.toString().slice(-2));
    } else if (format.includes("yy")) {
      format = format.replaceAll("yy", year.toString().slice(-2));
    } else if (format.includes("y")) {
      format = format.replaceAll("y", year);
    }
    full_date = format;
  } else {
    full_date = NumberZero(day) + "/" + NumberZero(month + 1) + "/" + NumberZero(year, 4);
  }
  return full_date;
};
const toFixed = (number, size) => {
  if (number) {
    if (number === 0) {
      return "0.00";
    }
    if (size) {
      return Number(number)
        .toFixed(size)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } else {
      return Number(number)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
  } else {
    return "0.00";
  }
};
function total(array, key) {
  if (key) {
    return array.reduce((a, b) => a + (b[key] || 0), 0);
  } else {
    return array.reduce((a, b) => a + b, 0);
  }
}
const set_header = async (method_value, token, body) => {
  let requestOptions = {};
  if (token) {
    if (body) {
      requestOptions = {
        method: method_value,
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        cache: "no-cache",
        body: body,
      };
    } else {
      requestOptions = {
        method: method_value,
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        cache: "no-cache",
      };
    }
  } else if (body) {
    requestOptions = {
      method: method_value,
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      cache: "no-cache",
      body: body,
    };
  } else {
    requestOptions = {
      method: method_value,
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      cache: "no-cache",
    };
  }
  return requestOptions;
};
const validate = (state, validate) => {
  for (let v of validate) {
    if (state[v] === "" || state[v] === null || (state[v] && state[v].length === 0)) {
      alert("warning", "แจ้งเตือน", "กรุณากรอกข้อมูลให้ครบถ้วน");
      return true;
    }
  }
  return false;
};
const required = <span className="text-danger mx-1">*</span>;
async function GET(token, url, body) {
  let ip_address = localStorage.getItem("ip_address");
  ip_address = ip_address ? `http://${ip_address}:8080/` : "";
  let promise = new Promise(async function (resolve, reject) {
    let header = await set_header("GET", token, null);
    let text_body = "";
    if (body) {
      let array_body = Object.entries(body);
      text_body += "?";
      for (let bd of array_body) {
        // encode กันค่าที่มี & # + ? = ทำ query string เพี้ยน (ค่า null/undefined ยังส่งเป็นข้อความเหมือนเดิม)
        text_body += encodeURIComponent(bd[0]) + "=";
        text_body += encodeURIComponent(bd[1]) + "&";
      }
      text_body = text_body.slice(0, -1);
    }
    url = url.includes("://") ? url : (ip_address || process.env.REACT_APP_API_URL) + url;
    await fetch(url + text_body, header)
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
        } else {
          ERROR(result);
          resolve(null);
        }
      })
      .catch((e) => {
        alert("warning", "แจ้งเตือน", "เกิดข้อผิดพลาด");
        resolve(null);
      });
  });
  return promise;
}
async function POST(token, url, body) {
  let ip_address = localStorage.getItem("ip_address");
  ip_address = ip_address ? `http://${ip_address}:8080/` : "";

  let promise = new Promise(async function (resolve, reject) {
    let header = await set_header("POST", token, JSON.stringify(body));
    await fetch(url?.includes("://") ? url : ((ip_address || process.env.REACT_APP_API_URL) + url), header)
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
        } else {
          ERROR(result);
          resolve(null);
        }
      })
      .catch((e) => {
        console.error(e);
        alert("warning", "แจ้งเตือน", "เกิดข้อผิดพลาด");
        resolve(null);
      });
  });
  return promise;
}
async function PUT(token, url, body) {
  let ip_address = localStorage.getItem("ip_address");
  ip_address = ip_address ? `http://${ip_address}:8080/` : "";
  let promise = new Promise(async function (resolve, reject) {
    let header = await set_header("PUT", token, JSON.stringify(body));
    await fetch(url?.includes("://") ? url : (ip_address || process.env.REACT_APP_API_URL) + url, header)
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
        } else {
          ERROR(result);
          resolve(null);
        }
      })
      .catch((e) => {
        alert("warning", "แจ้งเตือน", "เกิดข้อผิดพลาด");
        resolve(null);
      });
  });
  return promise;
}
async function DELETE(token, url, body) {
  let ip_address = localStorage.getItem("ip_address");
  ip_address = ip_address ? `http://${ip_address}:8080/` : "";
  let promise = new Promise(async function (resolve, reject) {
    let header = await set_header("DELETE", token, body ? JSON.stringify(body) : null);
    await fetch((ip_address || process.env.REACT_APP_API_URL) + url, header)
      .then((result) => result.json())
      .then((result) => {
        if (result.status) {
          resolve(result);
        } else {
          ERROR(result);
          resolve(null);
        }
      })
      .catch((e) => {
        alert("warning", "แจ้งเตือน", "เกิดข้อผิดพลาด");
        resolve(null);
      });
  });
  return promise;
}
async function ERROR(result) {
  let message = "";
  if (result.detail) {
    message = result.detail;
  } else if (result.data && !result.data.message) {
    message = result.data;
  } else if (result.data.message) {
    message = result.data.message;
  } else {
    message = result.message;
  }
  if (message === "ไม่พบโทเค็น") {
    Logout();
  } else {
    alert("warning", "แจ้งเตือน", message);
  }
}
async function gen_password(count) {
  let result = "";
  let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < count; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
function number(num) {
  return num.replace(/\D/g, "");
}
function float(num, count) {
  if (count === 3 && /^\d*\.?\d{0,3}$/.test(num)) {
    return true;
  } else if (/^\d*\.?\d{0,2}$/.test(num)) {
    return true;
  }
  return false;
}
class DatePicker extends Component {
  state = {
    value: "",
    default: new Date(),
    array_date: [],
    array_month: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
    array_year: [],
    showCalendar: false,
    min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
    max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
  };
  componentDidMount = () => {
    let year = [];
    for (let i = -100; i < 100; i++) {
      year.push(new Date().getFullYear() + i);
    }
    this.setState({ array_year: year });
    if (this.props.value) {
      this.setState({ default: new Date(this.props.value), value: new Date(this.props.value) });
    }
    if (this.props.min) {
      this.setState({ min: new Date(this.props.min) });
    }
    if (this.props.max) {
      this.setState({ max: new Date(this.props.max) });
    }
    this.getDates();
  };
  componentWillReceiveProps = (props) => {
    if (props.min) {
      this.setState({ min: new Date(props.min) });
    }
    if (props.max) {
      this.setState({ max: new Date(props.max) });
    }
    if (props.value) {
      this.setState({ default: new Date(props.value), value: new Date(props.value) });
    } else {
      this.setState({ default: new Date(), value: "" });
    }
  };
  onChangeDate = (option) => {
    if (option === "") {
      this.props.onChange("");
    } else {
      this.props.onChange(Number(option.getFullYear()) + "-" + ("0" + (Number(option.getMonth()) + 1)).slice(-2) + "-" + ("0" + option.getDate()).slice(-2));
    }
    this.setState({ value: option, showCalendar: false });
  };
  getDates = () => {
    let dates = [];
    let date = new Date(this.state.default.getFullYear(), this.state.default.getMonth(), 1);
    for (let d = 0; d < new Date(date).getDay(); d++) {
      dates.push("");
    }
    while (date.getMonth() === this.state.default.getMonth()) {
      dates.push(new Date(date).getDate());
      date.setDate(date.getDate() + 1);
    }
    this.setState({ array_date: dates });
  };
  render() {
    return (
      <div className="w-100 position-relative" style={{ minHeight: 44 }}>
        {this.state.showCalendar && (
          <div
            style={{ bottom: 0, left: 0, top: 0, right: 0, backgroundColor: "#0000", zIndex: 1000, position: "fixed" }}
            onClick={() => {
              this.setState({ showCalendar: false });
            }}
          ></div>
        )}
        <div className="w-100">
          <input
            className={this.props.className + " pointer"}
            type="text"
            value={this.state.value ? ("0" + this.state.value.getDate()).slice(-2) + "/" + ("0" + (Number(this.state.value.getMonth()) + 1)).slice(-2) + "/" + (Number(this.state.value.getFullYear()) + 543) : ""}
            placeholder={this.state.placeholder ? this.state.placeholder : "dd/mm/yyyy"}
            onFocus={() => {
              this.setState({ showCalendar: true });
              if (this.state.value) {
                this.setState({ default: new Date(this.state.value) });
                setTimeout(() => {
                  this.getDates();
                }, 10);
              } else {
                this.setState({ default: new Date() });
                setTimeout(() => {
                  this.getDates();
                }, 10);
              }
            }}
            disabled={this.props.disabled}
          />
          {this.state.showCalendar && (
            <div className="card rounded py-2 shadow position-absolute" style={{ zIndex: 1001, width: 300, marginTop: this.props.position === "top" ? -410 : 10 }}>
              <div className="d-flex justify-content-between align-items-center">
                {this.state.default.getMonth() === 0 && this.state.default.getFullYear() === new Date().getFullYear() - 100 ? (
                  <span className="p-3 pointer text-light">{"<"}</span>
                ) : (
                  <span
                    className="p-3 pointer"
                    onClick={() => {
                      let date = this.state.default;
                      date.setMonth(date.getMonth() - 1);
                      this.setState({ default: date });
                      setTimeout(() => {
                        this.getDates();
                      }, 1);
                    }}
                  >
                    {"<"}
                  </span>
                )}
                {/* เดือน */}
                <select
                  className="wpx-100 border-0 select-none text-center"
                  onChange={(e) => {
                    let date = this.state.default;
                    date.setMonth(e.target.value);
                    this.setState({ default: date });
                    setTimeout(() => {
                      this.getDates();
                    }, 1);
                  }}
                  value={this.state.default ? this.state.default.getMonth() : ""}
                >
                  {this.state.array_month.map((item, index) => (
                    <option key={"option" + index} value={index}>
                      {item}
                    </option>
                  ))}
                </select>
                <label className="mb-0 pointer mx-2">พ.ศ.</label>
                {/* ปี */}
                <select
                  className="wpx-60 border-0 select-none text-center"
                  onChange={(e) => {
                    let date = this.state.default;
                    date.setFullYear(e.target.value);
                    this.setState({ default: date });
                    setTimeout(() => {
                      this.getDates();
                    }, 1);
                  }}
                  value={this.state.default ? this.state.default.getFullYear() : ""}
                >
                  {this.state.array_year.map((item, index) => (
                    <option key={"option" + index} value={item}>
                      {item + 543}
                    </option>
                  ))}
                </select>
                {this.state.default.getMonth() === 11 && this.state.default.getFullYear() === new Date().getFullYear() + 99 ? (
                  <span className="p-3 pointer text-light">{">"}</span>
                ) : (
                  <span
                    className="p-3 pointer"
                    onClick={() => {
                      let date = this.state.default;
                      date.setMonth(date.getMonth() + 1);
                      this.setState({ default: date });
                      setTimeout(() => {
                        this.getDates();
                      }, 1);
                    }}
                  >
                    {">"}
                  </span>
                )}
              </div>
              <div className="w-100 d-flex row mx-0">
                <div className="py-1 text-center" style={{ width: "14.28%" }}>
                  {" "}
                  อา.{" "}
                </div>
                <div className="py-1 text-center" style={{ width: "14.28%" }}>
                  {" "}
                  จ.{" "}
                </div>
                <div className="py-1 text-center" style={{ width: "14.28%" }}>
                  {" "}
                  อ.{" "}
                </div>
                <div className="py-1 text-center" style={{ width: "14.28%" }}>
                  {" "}
                  พ.{" "}
                </div>
                <div className="py-1 text-center" style={{ width: "14.28%" }}>
                  {" "}
                  พฤ.{" "}
                </div>
                <div className="py-1 text-center" style={{ width: "14.28%" }}>
                  {" "}
                  ศ.{" "}
                </div>
                <div className="py-1 text-center" style={{ width: "14.28%" }}>
                  {" "}
                  ส.{" "}
                </div>
              </div>
              <div className="w-100 d-flex row mx-0" style={{ height: 220 }}>
                {this.state.array_date.map((item, index) => (
                  <div
                    className={
                      this.state.value && item && this.state.value.getDate() === item && this.state.value.getMonth() === this.state.default.getMonth() && this.state.value.getFullYear() === this.state.default.getFullYear()
                        ? new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()
                          ? "py-1 text-center pointer bg-primary text-white d-flex align-items-center justify-content-center"
                          : "py-1 text-center bg-primary text-white d-flex align-items-center justify-content-center text-light"
                        : new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()
                        ? "py-1 text-center pointer d-flex align-items-center justify-content-center"
                        : "py-1 text-center d-flex align-items-center justify-content-center text-light"
                    }
                    style={{ width: "14.28%" }}
                    onClick={() => {
                      if (new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) > this.state.min.getTime() && new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item) < this.state.max.getTime()) {
                        this.onChangeDate(new Date(this.state.default.getFullYear(), this.state.default.getMonth(), item));
                      }
                    }}
                  >
                    {item}
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-between px-2">
                <label
                  className="pointer text-primary"
                  onClick={() => {
                    this.onChangeDate("");
                  }}
                >
                  clear
                </label>
                <label
                  className="pointer text-primary"
                  onClick={() => {
                    this.onChangeDate(new Date());
                  }}
                >
                  To day
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
const select_height = 44;
const select_style = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    height: select_height,
    minHeight: select_height,
    padding: 0,
    border: 0,
    backgroundColor: "#00000000",
    boxShadow: "none",
  }),
  valueContainer: (baseStyles, state) => ({
    ...baseStyles,
    height: select_height,
    paddingTop: 0,
    paddingLeft: 12,
    paddingBottom: 0,
  }),
  input: (baseStyles, state) => ({
    ...baseStyles,
    height: select_height,
    minHeight: select_height,
    padding: 0,
    margin: 0,
  }),
};
function removeStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("username");
  localStorage.removeItem("full_name");
  localStorage.removeItem("user_code");
  localStorage.removeItem("user_type");
  localStorage.removeItem("role_detail");
  localStorage.removeItem("first_page");
  localStorage.removeItem("project_id");
  localStorage.removeItem("project_number");
  localStorage.removeItem("project_name");
  localStorage.removeItem("project_address");
  localStorage.removeItem("phone_number");
  localStorage.removeItem("tax_number");
  localStorage.removeItem("water_id");
  localStorage.removeItem("receipt_id");
  localStorage.removeItem("room_id");
  localStorage.removeItem("letter_id");
  localStorage.removeItem("photo");
  // ข้อมูลผู้ใช้/โครงการที่ค้างจากรอบก่อน (ไม่ล้าง ip_address = ค่าตั้งเครื่อง on-prem, sync_date = รอบ sync รายวัน)
  localStorage.removeItem("user_id");
  localStorage.removeItem("picture_paper");
  localStorage.removeItem("replace_text");
  localStorage.removeItem("DATA_");
}
function getStorage(type) {
  let data = {
    token: localStorage.getItem("token"),
    username: localStorage.getItem("username"),
    full_name: localStorage.getItem("full_name"),
    user_code: localStorage.getItem("user_code"),
    user_id: localStorage.getItem("user_id"),
    user_type: localStorage.getItem("user_type"),
    role_detail: JSON.parse(localStorage.getItem("role_detail")),
    first_page: localStorage.getItem("first_page"),
    project_id: localStorage.getItem("project_id"),
    project_number: localStorage.getItem("project_number"),
    project_name: localStorage.getItem("project_name"),
    project_address: localStorage.getItem("project_address"),
    phone_number: localStorage.getItem("phone_number"),
    tax_number: localStorage.getItem("tax_number"),
    water_id: localStorage.getItem("water_id"),
    receipt_id: localStorage.getItem("receipt_id"),
    room_id: localStorage.getItem("room_id"),
    letter_id: localStorage.getItem("letter_id"),
    picture_paper: localStorage.getItem("picture_paper"),
  };
  if (type === "photo") {
    data.photo = localStorage.getItem("photo").includes("base64") ? localStorage.getItem("photo") : "data:image/png;base64," + localStorage.getItem("photo");
  }
  return data[type];
}
class Icon extends Component {
  state = {};
  componentDidMount = () => {};
  render() {
    return (
      <span className={"icon-light" + (this.props.color ? " text-" + this.props.color : " text-dark") + (this.props.className ? " " + this.props.className : "")} style={{ fontSize: this.props.size ? this.props.size : 16 }}>
        {this.props.icon}
      </span>
    );
  }
}
function roundToTwo(num) {
  return num ? Math.ceil(Number(num.toString()) * 100) / 100 : 0;
}
function fieldSorter(fields) {
  return function (a, b) {
    return fields
      .map(function (o) {
        let dir = 1;
        if (o[0] === "-") {
          dir = -1;
          o = o.substring(1);
        }
        if (a[o] > b[o]) return dir;
        if (a[o] < b[o]) return -dir;
        return 0;
      })
      .reduce(function firstNonZeroValue(p, n) {
        return p || n;
      }, 0);
  };
}
function base64(img) {
  return img.includes("base64") ? img : img.includes("http") ? img : "data:image/png;base64," + img;
}

const replaceText = async (docDefinition) => {
  let result = await GET(tokens, "v1/TH/water-manage/detail/" + localStorage.getItem("water_id"), null);

  let water_bill_text = result.data.data.water_bill_text || "ค่าน้ำประปา";
  let meter_connect_cost_text = result.data.data.meter_connect_cost_text || "ค่าต่อมิเตอร์";
  let equipment_maintenance_fee_text = result.data.data.equipment_maintenance_fee_text || "ค่าบริการอุปกรณ์";
  let waste_cost_text = result.data.data.waste_cost_text || "ค่าขยะ";
  let common_expenses_text = result.data.data.common_expenses_text || "ค่าส่วนกลาง";
  let fire_cost_text = result.data.data.fire_cost_text || "ค่าเบี้ยประกัน";
  let cable_cost_text = result.data.data.cable_cost_text || "ค่าเคเบิล";

  let text = JSON.stringify(docDefinition);
  text = text.replace(/ค่าน้ำประปา|ค่าน้ำ ประปา|ค่าน้ำประปา|ค่าใช้น้ำ/g, water_bill_text);
  text = text.replace(/ค่าต่อกลับ มิเตอร์|ค่าต่อ มิเตอร์|ค่าต่อมิเตอร์|ค่าต่อกลับมิเตอร์/g, meter_connect_cost_text);
  text = text.replace(/ค่าขยะ|ค่าจัดเก็บขยะ|ค่าบริการจัดเก็บขยะ/g, waste_cost_text);
  text = text.replace(/ค่าใช้จ่ายส่วนกลาง|ค่าส่วนกลาง|ค่าส่วน\s*กลาง|ค่า\s*ส่วนกลาง|ค่า ส่วนกลาง|ค่าใช้จ่าย\s*ส่วนกลาง/g, common_expenses_text);
  text = text.replace(/ค่าประกันอัคคีภัย|ค่าเบี้ยประกัน/g, fire_cost_text);
  text = text.replace(/ค่าเคเบิล|ค่าบริการเคเบิล/g, cable_cost_text);
  text = text.replace(/ค่ารักษา อุปกรณ์น้ำ|ค่าบริการรักษาอุปกรณ์น้ำ|ค่ารักษาอุปกรณ์การใช้น้ำ|ค่าบริการอุปกรณ์|ค่ารักษาอุปกรณ์น้ำ|ค่ารักษาอุปกรณ์|ค่าบริการ\s*อุปกรณ์|ค่ารักษา อุปกรณ์|ค่ารักษา\s*อุปกรณ์|ค่าบริการ/g, equipment_maintenance_fee_text);

  return JSON.parse(text);
};
const loadReplaceTextHTML = async () => {
  console.log("loadReplaceTextHTML")
  let replace_text = localStorage.getItem("replace_text");
  
  if (replace_text) {
    replace_text = JSON.parse(replace_text);
    const currentTime = new Date().getTime();
    
    // ถ้าเวลาใน datetime_create ยังมากกว่าเวลาปัจจุบัน (ยังไม่หมดอายุ) ให้หยุดการทำงานและใช้ข้อมูลเดิม
    if (replace_text.datetime_create > currentTime) {
      return; 
    }
    // ถ้าเวลาน้อยกว่าเวลาปัจจุบัน (หมดอายุแล้ว) โค้ดจะทำงานทะลุลงไปดึง API ด้านล่าง
  }

  // ดึงข้อมูลจาก API ใหม่
  let result = await GET(tokens, "v1/TH/water-manage/detail/" + localStorage.getItem("water_id"), null);

  let water_bill_text = result.data.data.water_bill_text || "ค่าน้ำประปา";
  let meter_connect_cost_text = result.data.data.meter_connect_cost_text || "ค่าต่อมิเตอร์";
  let equipment_maintenance_fee_text = result.data.data.equipment_maintenance_fee_text || "ค่าบริการอุปกรณ์";
  let waste_cost_text = result.data.data.waste_cost_text || "ค่าขยะ";
  let common_expenses_text = result.data.data.common_expenses_text || "ค่าส่วนกลาง";
  let fire_cost_text = result.data.data.fire_cost_text || "ค่าเบี้ยประกัน";
  let cable_cost_text = result.data.data.cable_cost_text || "ค่าเคเบิล";
  
  // คำนวณเวลา 30 นาที (30 นาที * 60 วินาที * 1000 มิลลิวินาที = 1,800,000 มิลลิวินาที)
  const expireTime = new Date().getTime() + (30 * 60 * 1000);

  // เก็บข้อมูลใหม่ลง localStorage พร้อมเซ็ตเวลาใหม่ (ใช้ JSON.stringify เพื่อแปลง Object เป็น String)
  localStorage.setItem("replace_text", JSON.stringify({
    datetime_create: expireTime,
    water_bill_text,
    meter_connect_cost_text,
    equipment_maintenance_fee_text,
    waste_cost_text,
    common_expenses_text,
    fire_cost_text,
    cable_cost_text,
  }));
};
const replaceTextHTML = async () => {
  console.log("replaceTextHTML")
  let replace_text = localStorage.getItem("replace_text");
  
  if (replace_text) {
    replace_text = JSON.parse(replace_text);
    
  }
  let water_bill_text = replace_text?.water_bill_text || "ค่าน้ำประปา";
  let meter_connect_cost_text = replace_text?.meter_connect_cost_text || "ค่าต่อมิเตอร์";
  let equipment_maintenance_fee_text = replace_text?.equipment_maintenance_fee_text || "ค่าบริการอุปกรณ์";
  let waste_cost_text = replace_text?.waste_cost_text || "ค่าขยะ";
  let common_expenses_text = replace_text?.common_expenses_text || "ค่าส่วนกลาง";
  let fire_cost_text = replace_text?.fire_cost_text || "ค่าเบี้ยประกัน";
  let cable_cost_text = replace_text?.cable_cost_text || "ค่าเคเบิล";
  document.body.querySelectorAll("*").forEach((el) => {
    el.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.textContent;

        text = text.includes(water_bill_text) ? text : text.replace(/ค่าน้ำประปา|ค่าน้ำ ประปา|ค่าน้ำประปา|ค่าใช้น้ำ/g, water_bill_text); 
        text = text.includes(meter_connect_cost_text) ? text : text.replace(/ค่าต่อกลับ มิเตอร์|ค่าต่อ มิเตอร์|ค่าต่อมิเตอร์|ค่าต่อกลับมิเตอร์/g, meter_connect_cost_text);
        text = text.includes(waste_cost_text) ? text : text.replace(/ค่าขยะ|ค่าจัดเก็บขยะ|ค่าบริการจัดเก็บขยะ/g, waste_cost_text);
        text = text.includes(common_expenses_text) ? text : text.replace(/ค่าใช้จ่ายส่วนกลาง|ค่าส่วนกลาง|ค่าส่วน\s*กลาง|ค่า\s*ส่วนกลาง|ค่า ส่วนกลาง|ค่าใช้จ่าย\s*ส่วนกลาง/g, common_expenses_text);
        text = text.includes(fire_cost_text) ? text : text.replace(/ค่าประกันอัคคีภัย|ค่าเบี้ยประกัน/g, fire_cost_text);
        text = text.includes(cable_cost_text) ? text : text.replace(/ค่าเคเบิล|ค่าบริการเคเบิล/g, cable_cost_text);
        text = text.includes(equipment_maintenance_fee_text) ? text : text.replace(/ค่ารักษา อุปกรณ์น้ำ|ค่าบริการรักษาอุปกรณ์น้ำ|ค่ารักษาอุปกรณ์การใช้น้ำ|ค่าบริการอุปกรณ์|ค่ารักษาอุปกรณ์น้ำ|ค่ารักษาอุปกรณ์|ค่าบริการ\s*อุปกรณ์|ค่ารักษา อุปกรณ์|ค่ารักษา\s*อุปกรณ์|ค่าบริการ/g, equipment_maintenance_fee_text);

        if (node.textContent !== text) {
          node.textContent = text;
        }
      }
    });
  });
};

// ===== คำนวณค่าน้ำ 3 แบบ =====
// setting มาจาก API v1/TH/water-manage/detail/<water_id>
//   { water_charge_start, water_charge_end, water_charge_price, water_rate_list: [{ water_rate_start, water_rate_end, water_rate_price }] }
// ตัวอย่าง setting ที่ใช้อ้างอิงตัวเลขในคอมเมนต์ด้านล่าง (ตามไฟล์ Excel ที่ลูกค้าส่งมา):
//   ขั้นต่ำ 0-4 = 70 บาท | ขั้น 5-10 = 14.7 | ขั้น 11-20 = 15 | ขั้น 21-30 = 20
//
//   แบบ 1 cal_water_bill_1 (ขั้นบันไดตั้งแต่ขั้นที่ 3) : 4→70, 10→147, 20→297, 30→497
//   แบบ 2 cal_water_bill_2 (ขั้นบันไดแท้)              : 4→70, 10→158.2, 20→308.2, 30→508.2
//   แบบ 3 cal_water_bill_3 (เหมารวม)                   : 4→70, 10→147, 20→300, 30→600

// อ่าน setting จาก API ให้เป็นตัวเลขล้วน (ตัด comma ที่มาจาก toFixed ฝั่งหน้าจอออก)
const parse_water_setting = (setting) => {
  const to_number = (value) => Number(String(value ?? 0).replace(/,/g, "")) || 0;
  return {
    charge_end: to_number(setting?.water_charge_end),
    charge_price: to_number(setting?.water_charge_price),
    tiers: (setting?.water_rate_list || [])
      .map((w) => ({
        start: to_number(w.water_rate_start),
        end: to_number(w.water_rate_end),
        price: to_number(w.water_rate_price),
      }))
      .sort((a, b) => a.start - b.start),
  };
};

// log ขั้นตอนการคิดเงินลง console (ใช้ร่วมกันทั้ง 3 แบบ)
const log_water_bill = (mode, unit_used, setting, steps, result, note) => {
  console.groupCollapsed(`[${mode}] หน่วยที่ใช้ ${unit_used} -> ${toFixed(result)} บาท (${note})`);
  console.log("input:", {
    unit_used,
    water_charge_end: setting?.water_charge_end,
    water_charge_price: setting?.water_charge_price,
    water_rate_list: setting?.water_rate_list,
  });
  if (steps.length) console.table(steps);
  console.log("water_bill:", result);
  console.groupEnd();
  return result;
};

const round2 = (value) => parseFloat(value.toFixed(2));

// แบบ 1 : ขั้นบันไดตั้งแต่ขั้นที่ 3
//   ขั้นที่ 1 (0-4)   -> เหมาจ่ายอัตราขั้นต่ำ 70
//   ขั้นที่ 2 (5-10)  -> เหมารวม คิดราคาขั้นนี้คูณหน่วยทั้งหมด (10 หน่วย x 14.7 = 147)
//   ขั้นที่ 3 ขึ้นไป  -> ยอดเต็มของขั้นที่ 2 (147) + คิดขั้นบันไดเฉพาะหน่วยส่วนเกินของแต่ละขั้น
//   เช่น 20 หน่วย = 147 + (20-10) x 15 = 297 | 30 หน่วย = 297 + (30-20) x 20 = 497
const cal_water_bill_1 = (unit_used, setting) => {
  const u = Number(unit_used);
  const steps = [];
  const done = (result, note) => log_water_bill("cal_water_bill_1 ขั้นบันไดตั้งแต่ขั้นที่ 3", unit_used, setting, steps, result, note);

  if (!isFinite(u) || u < 0) return done(0, "หน่วยติดลบ/ไม่ใช่ตัวเลข คิด 0");

  const { charge_end, charge_price, tiers } = parse_water_setting(setting);

  if (u <= charge_end) {
    steps.push({ ขั้น: "ขั้นที่ 1 (ขั้นต่ำ)", ช่วง: `0-${charge_end}`, หน่วยที่คิด: u, ราคาต่อหน่วย: "เหมาจ่าย", เป็นเงิน: charge_price, ยอดสะสม: charge_price });
    return done(round2(charge_price), "ไม่เกินอัตราขั้นต่ำ");
  }

  const first = tiers[0];
  if (!first) {
    steps.push({ ขั้น: "ขั้นที่ 1 (ขั้นต่ำ)", ช่วง: `0-${charge_end}`, หน่วยที่คิด: u, ราคาต่อหน่วย: "เหมาจ่าย", เป็นเงิน: charge_price, ยอดสะสม: charge_price });
    return done(round2(charge_price), "ไม่ได้ตั้งขั้นราคาไว้ ใช้อัตราขั้นต่ำ");
  }

  // ยังอยู่ในขั้นที่ 2 -> เหมารวมทั้งหมดด้วยราคาขั้นนี้
  if (u <= first.end) {
    const amount = u * first.price;
    steps.push({ ขั้น: "ขั้นที่ 2 (เหมารวม)", ช่วง: `1-${u}`, หน่วยที่คิด: u, ราคาต่อหน่วย: first.price, เป็นเงิน: round2(amount), ยอดสะสม: round2(amount) });
    return done(round2(amount), "อยู่ในขั้นที่ 2 คิดเหมารวม");
  }

  // ขั้นที่ 3 ขึ้นไป -> ตั้งต้นด้วยยอดเต็มของขั้นที่ 2 แล้วคิดขั้นบันไดต่อ
  let price = first.end * first.price;
  let counted = first.end;
  let last_price = first.price;
  steps.push({ ขั้น: "ขั้นที่ 2 (เหมารวมเต็มขั้น)", ช่วง: `1-${first.end}`, หน่วยที่คิด: first.end, ราคาต่อหน่วย: first.price, เป็นเงิน: round2(price), ยอดสะสม: round2(price) });

  for (const t of tiers.slice(1)) {
    if (u < t.start) {
      steps.push({ ขั้น: `${t.start}-${t.end}`, ช่วง: `${t.start}-${t.end}`, หน่วยที่คิด: 0, ราคาต่อหน่วย: t.price, เป็นเงิน: 0, ยอดสะสม: round2(price), หมายเหตุ: "ยังไม่ถึงขั้นนี้ หยุดคิด" });
      break;
    }
    last_price = t.price;
    const upto = Math.min(u, t.end);
    const units = upto > counted ? upto - counted : 0;
    const amount = units * t.price;
    const from = counted;
    if (units > 0) {
      price += amount;
      counted = upto;
    }
    steps.push({ ขั้น: `${t.start}-${t.end}`, ช่วง: `${from}-${upto}`, หน่วยที่คิด: units, ราคาต่อหน่วย: t.price, เป็นเงิน: round2(amount), ยอดสะสม: round2(price) });
  }

  if (u > counted) {
    const units = u - counted; // เกินขั้นสุดท้าย ใช้ราคาขั้นสุดท้าย
    const amount = units * last_price;
    price += amount;
    steps.push({ ขั้น: "เกินขั้นสุดท้าย", ช่วง: `${counted}-${u}`, หน่วยที่คิด: units, ราคาต่อหน่วย: last_price, เป็นเงิน: round2(amount), ยอดสะสม: round2(price) });
  }

  return done(round2(price), "ขั้นบันไดตั้งแต่ขั้นที่ 3");
};

// แบบ 2 : ขั้นบันไดแท้ (marginal) คิดเฉพาะหน่วยส่วนเกินของแต่ละขั้น
//   0-4 = 70 | 5-10 = 6 หน่วย x 14.7 = 88.2 | 11-20 = 10 x 15 = 150 | 21-30 = 10 x 20 = 200
//   30 หน่วย = 70 + 88.2 + 150 + 200 = 508.2
const cal_water_bill_2 = (unit_used, setting) => {
  const u = Number(unit_used);
  const steps = [];
  const done = (result, note) => log_water_bill("cal_water_bill_2 ขั้นบันไดแท้", unit_used, setting, steps, result, note);

  if (!isFinite(u) || u < 0) return done(0, "หน่วยติดลบ/ไม่ใช่ตัวเลข คิด 0");

  const { charge_end, charge_price, tiers } = parse_water_setting(setting);

  if (u <= charge_end) {
    steps.push({ ขั้น: "ขั้นต่ำ", ช่วง: `0-${charge_end}`, หน่วยที่คิด: u, ราคาต่อหน่วย: "เหมาจ่าย", เป็นเงิน: charge_price, ยอดสะสม: charge_price });
    return done(round2(charge_price), "ไม่เกินอัตราขั้นต่ำ");
  }

  let price = charge_price;
  let counted = charge_end; // หน่วยที่คิดเงินไปแล้ว
  let last_price = 0;
  steps.push({ ขั้น: "ขั้นต่ำ", ช่วง: `0-${charge_end}`, หน่วยที่คิด: charge_end, ราคาต่อหน่วย: "เหมาจ่าย", เป็นเงิน: charge_price, ยอดสะสม: round2(price) });

  for (const t of tiers) {
    if (u < t.start) {
      steps.push({ ขั้น: `${t.start}-${t.end}`, ช่วง: `${t.start}-${t.end}`, หน่วยที่คิด: 0, ราคาต่อหน่วย: t.price, เป็นเงิน: 0, ยอดสะสม: round2(price), หมายเหตุ: "ยังไม่ถึงขั้นนี้ หยุดคิด" });
      break;
    }
    last_price = t.price;
    const upto = Math.min(u, t.end);
    const units = upto > counted ? upto - counted : 0;
    const amount = units * t.price;
    const from = counted;
    if (units > 0) {
      price += amount;
      counted = upto;
    }
    steps.push({ ขั้น: `${t.start}-${t.end}`, ช่วง: `${from}-${upto}`, หน่วยที่คิด: units, ราคาต่อหน่วย: t.price, เป็นเงิน: round2(amount), ยอดสะสม: round2(price) });
  }

  if (u > counted) {
    const units = u - counted; // เกินขั้นสุดท้าย ใช้ราคาขั้นสุดท้าย
    const amount = units * last_price;
    price += amount;
    steps.push({ ขั้น: "เกินขั้นสุดท้าย", ช่วง: `${counted}-${u}`, หน่วยที่คิด: units, ราคาต่อหน่วย: last_price, เป็นเงิน: round2(amount), ยอดสะสม: round2(price) });
  }

  return done(round2(price), "คิดตามขั้นบันไดแท้");
};

// แบบ 3 : เหมารวม คิดราคาของขั้นที่หน่วยตกอยู่ คูณจำนวนหน่วยทั้งหมด
//   ตัวอย่างจากไฟล์ Excel (ขั้นต่ำ 0-4 = 70, 5-10 = 15, 11-20 = 20, 21-30 = 30)
//   10 หน่วย = 10 x 15 = 150 | 20 หน่วย = 20 x 20 = 400 | 30 หน่วย = 30 x 30 = 900
const cal_water_bill_3 = (unit_used, setting) => {
  const u = Number(unit_used);
  const steps = [];
  const done = (result, note) => log_water_bill("cal_water_bill_3 เหมารวม", unit_used, setting, steps, result, note);

  if (!isFinite(u) || u < 0) return done(0, "หน่วยติดลบ/ไม่ใช่ตัวเลข คิด 0");

  const { charge_end, charge_price, tiers } = parse_water_setting(setting);

  if (u <= charge_end) {
    steps.push({ ขั้น: "ขั้นต่ำ", ช่วง: `0-${charge_end}`, หน่วยที่คิด: u, ราคาต่อหน่วย: "เหมาจ่าย", เป็นเงิน: charge_price, ยอดสะสม: charge_price });
    return done(round2(charge_price), "ไม่เกินอัตราขั้นต่ำ");
  }

  if (tiers.length === 0) {
    steps.push({ ขั้น: "ขั้นต่ำ", ช่วง: `0-${charge_end}`, หน่วยที่คิด: u, ราคาต่อหน่วย: "เหมาจ่าย", เป็นเงิน: charge_price, ยอดสะสม: charge_price });
    return done(round2(charge_price), "ไม่ได้ตั้งขั้นราคาไว้ ใช้อัตราขั้นต่ำ");
  }

  // ขั้นที่หน่วยตกอยู่ ถ้าเกินขั้นสุดท้ายใช้ราคาขั้นสุดท้าย
  const tier = tiers.find((t) => u >= t.start && u <= t.end) || tiers[tiers.length - 1];
  const over_last = u > tiers[tiers.length - 1].end;
  const price = u * tier.price;

  steps.push({
    ขั้น: over_last ? "เกินขั้นสุดท้าย" : `${tier.start}-${tier.end}`,
    ช่วง: `1-${u}`,
    หน่วยที่คิด: u,
    ราคาต่อหน่วย: tier.price,
    เป็นเงิน: round2(price),
    ยอดสะสม: round2(price),
  });

  return done(round2(price), over_last ? "เกินขั้นสุดท้าย คิดเหมารวมด้วยราคาขั้นสุดท้าย" : "คิดเหมารวมด้วยราคาของขั้นที่หน่วยตกอยู่");
};

// ตัวที่หน้าอื่นเรียกใช้ เลือกสูตรจาก setting.water_calculate_type (1/2/3) ค่าเริ่มต้น = แบบ 2 ขั้นบันไดแท้
const cal_water_bill = (unit_used, setting) => {
  const type = Number(setting?.water_calculate_type) || 2;
  if (type === 1) return cal_water_bill_1(unit_used, setting);
  if (type === 3) return cal_water_bill_3(unit_used, setting);
  return cal_water_bill_2(unit_used, setting);
};

const calculate_water = async (address_number) => {
  try {
    const [result, setting] = await Promise.all([GET(tokens, "v1/TH/record-receipt/filter-search/page/0/" + getStorage("project_id"), { address_number: address_number || "", building: "" }), GET(tokens, "v1/TH/water-manage/detail/" + getStorage("water_id"), null)]);
    const { penalty_day_list, penalty_month_list, meter_convergence, meter_cut_month, meter_cut_date } = setting.data.data;
    if (result?.status) {
      // แปลงค่าตัวแปรทั้งหมด
      let obj = result?.data?.data_water;
      obj = obj.sort(fieldSorter(["address_number", "datetime_create"]));
      console.log("obj", obj);
      obj = obj.map((item) => {
        return {
          address_number: item.address_number,
          datetime_create: item.datetime_create,
          record_water_id: item.record_water_id,
          // NOTE ยอดฐานไม่รวม meter_connect_cost เพราะค่าต่อกลับมิเตอร์ถูกคำนวณใหม่ในชั้นล่าง
          // แล้วบวกกลับเข้า total_amount ทีหลัง (ถ้าบวกค่าเดิมตรงนี้ด้วยจะคิดซ้ำทุกครั้งที่รันใหม่)
          total_amount:
          item.water_bill +
          item.equipment_maintenance_fee +
          item.common_expenses +
          item.waste_cost +
          item.cable_cost + 
          item.other_income + 
          item.add_debt + 
          item.fire_cost - 
          item.reduce_debt,
          total_cost_late: 0,
          total_month_late: countPassedSpecialDays(item.datetime_create, penalty_day_list),
          meter_connect_cost: 0,
          status_meter: 1,
        };
      });

      // จัด array ให้อยู่ในรูปตามแต่ละห้อง
      let array = Object.values(
        obj.reduce((acc, item) => {
          if (!acc[item.address_number]) {
            acc[item.address_number] = [];
          }
          acc[item.address_number].push(item);
          return acc;
        }, {})
      );
      // คำนวณ
      for (let room of array) {
        let check_meter = false;
        // เบี้ยปรับ
        for (let item of room) {
          for (let p of penalty_month_list) {
            if (p.month_start <= item.total_month_late && item.total_month_late <= p.month_end) {
              console.log("total_amount:", item.total_amount, "    total_month_late:", item.total_month_late, "    penalty_year_rate:", p.penalty_year_rate);
              item.total_cost_late = Number(((item.total_amount * item.total_month_late * (p.penalty_year_rate / 100)) / 12).toFixed(2));
              item.total_amount = Number(item.total_amount) + Number(item.total_cost_late);
            }
          }
        }
        room = room.sort(fieldSorter(["address_number", "datetime_create"]));
        // ค่าต่อกลับมิเตอร์
        const meter_cost = Number(meter_convergence) || 0;
        for (let item of room) {
          let month = 1;
          if (check_meter === false) {
            month = month + countPassedSpecialDays(item.datetime_create, [meter_cut_date]);
           if (meter_cut_month < month) {
              item.meter_connect_cost = meter_cost;
              // NOTE บวกเข้ายอดรวม ให้ตรงกับสูตรฝั่ง backend: ยอดฐาน + เบี้ยปรับ + ค่าต่อมิเตอร์
              item.total_amount = Number(item.total_amount) + meter_cost;
              item.status_meter = 2;
              check_meter = true;
            } else {
              item.meter_connect_cost = 0;
              item.status_meter = 1;
              check_meter = false;
            }
          }
        }
      }
      console.log("array:",array)

      array = array.flat();
      const chunks = [];
      for (let i = 0; i < array.length; i += 1000) {
        chunks.push(array.slice(i, i + 1000));
      }
      const results = await Promise.all(
        chunks.map(async (chunk) => {
          const body = { water_list: chunk };
          return await PUT(tokens, "v1/TH/record-water/re-update/" + getStorage("project_id"), body);
        })
      );

      // ตรวจสอบผลลัพธ์จากทุกการเรียก PUT
      if (results.every((result) => result && result.status)) {
        return true;
      }
      return true;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
};
function countPassedSpecialDays(startDateStr, specialDays) {
  const startDate = new Date(startDateStr);
  const endDate = new Date(); // วันนี้
  let count = 0;

  let year = startDate.getFullYear();
  let month = startDate.getMonth(); // 0 = มกราคม

  while (year < endDate.getFullYear() || (year === endDate.getFullYear() && month <= endDate.getMonth())) {
    for (const day of specialDays) {
      const specialDate = new Date(year, month, day);
      if (specialDate >= startDate && specialDate <= endDate) {
        count++;
      }
    }

    // ข้ามไปเดือนถัดไป
    month++;
    if (month > 11) {
      month = 0;
      year++;
    }
  }

  return count;
}

const loading = (status) => {
  try {
    const loading = document.getElementById("loading");
    if (status === true) {
      loading.classList.remove("d-none");
    } else if (status === false) {
      loading.classList.add("d-none");
    }
  } catch (e) {}
};
class Select extends Component {
  state = {
    showSelectOption: false,
    search: "",
    selected: "",
  };
  componentDidMount = () => {};
  componentWillReceiveProps = (props) => {};
  render() {
    return (
      <div
        style={{ position: "relative", padding: 0 }}
        className={this.props.className}
      >
        {this.state.showSelectOption && (
          <div
            style={{
              bottom: 0,
              left: 0,
              top: 0,
              right: 0,
              backgroundColor: "#0000",
              zIndex: 1000,
              position: "fixed",
            }}
            onClick={() => {
              this.setState({ showSelectOption: false });
            }}
          ></div>
        )}
        <div style={{ position: "relative" }}>
          {!this.state.search &&
          !this.state.showSelectOption &&
          this.props.options?.find((e) => e.value === this.props.value)
            ?.front ? (
            <div className="position-absolute mx-2 mt-1">
              {
                this.props.options?.find((e) => e.value === this.props.value)
                  ?.front
              }
            </div>
          ) : null}
          <input
            className={this.props.className
              ?.replaceAll("mb-2", "")
              .replaceAll("mb-3", "")
              .replaceAll("mb-4", "")
              .replaceAll("mb-5", "")}
            style={{
              width: "100%",
              backgroundColor: this.props.disabled ? "#e9ecef" : "#00000000",
              border: 0,
              paddingLeft:
                !this.state.search &&
                !this.state.showSelectOption &&
                this.props.options?.find((e) => e.value === this.props.value)
                  ?.front
                  ? 36
                  : ".75rem",
            }}
            type="text"
            value={
              !this.state.search &&
              !this.state.showSelectOption &&
              this.props.value
                ? this.props.options?.find((e) => e.value === this.props.value)
                    ?.label
                : this.state.search
            }
            placeholder={this.props.placeholder || ""}
            onFocus={() => {
              this.setState({
                showSelectOption: true,
                search: "",
                selected: "",
              });
            }}
            onChange={(e) => {
              this.setState({ search: e.target.value });
            }}
            disabled={this.props.disabled}
          />
          <div
            style={{
              display: "flex",
              position: "absolute",
              right: 8,
              top: "50%",
            }}
          >
            <div
              style={{
                width: 7,
                height: 1.7,
                backgroundColor: "#232323",
                transform: "rotate(45deg)",
                borderRadius: 1,
              }}
            ></div>
            <div
              style={{
                width: 7,
                height: 1.7,
                backgroundColor: "#232323",
                transform: "rotate(315deg)",
                marginLeft: -3.2,
                borderRadius: 1,
              }}
            ></div>
          </div>
        </div>
        {this.state.showSelectOption && (
          <div
            id="select-tool"
            style={{
              minWidth: 150,
              width: "100%",
              padding: 6,
              borderRadius: 6,
              borderWidth: 1,
              borderColor: "#d2d2d2",
              borderStyle: "solid",
              backgroundColor: "#fdfdfd",
              position: "absolute",
              top: 40,
              zIndex: 1001,
            }}
          >
            <div
              style={{
                maxHeight: 400,
                overflow: "scroll",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {this.props.options?.filter(
                (e) => !this.state.search || e.label.includes(this.state.search)
              ).length !== 0 &&
                this.props.default !== false && (
                  <div
                    style={{
                      width: "100%",
                      cursor: "pointer",
                      padding: 4,
                      backgroundColor:
                        this.state.selected === "" ? "#dfdfdf" : "#fff0",
                      color:
                       "#000000",
                    }}
                    onClick={() => {
                      this.setState({
                        showSelectOption: false,
                        search: "",
                        selected: "",
                      });
                      this.props.onChange("", { value: "", label: "" });
                    }}
                    onMouseEnter={() => this.setState({ selected: "" })}
                  >
                    -- กรุณาเลือก --
                  </div>
                )}
              {this.props.options
                ?.filter(
                  (e) =>
                    !this.state.search || e.label.includes(this.state.search)
                )
                .map((item, index) => (
                  <div
                    key={`array-${index}`}
                    style={{
                      display: "flex",
                      width: "100%",
                      cursor: "pointer",
                      padding: 4,
                      backgroundColor:
                        this.state.selected === item.value
                          ? "#dfdfdf"
                          : "#fff0",
                      color:"#000000",
                    }}
                    onClick={() => {
                      this.setState({
                        showSelectOption: false,
                        search: "",
                        selected: "",
                      });
                      this.props.onChange(item.value, item);
                    }}
                    onMouseEnter={() => this.setState({ selected: item.value })}
                  >
                    {item.front || ""}
                    {item.label}
                  </div>
                ))}
              <div style={{ maxHeight: 300, overflow: "scroll" }}>
                {this.props.options?.filter(
                  (e) =>
                    !this.state.search || e.label.includes(this.state.search)
                ).length === 0 && (
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "#2c2c2c",
                    }}
                  >
                    ไม่พบข้อมูล...
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export { tokens, select_style, total, success, success_url, alert, alert_url, alert_2, toFixed, GET, POST, PUT, DELETE, gen_password, format_date, number, float, validate, required, DatePicker, NumberZero, Logout, removeStorage, getStorage, Icon, roundToTwo, fieldSorter, base64, loading, replaceText, replaceTextHTML, loadReplaceTextHTML, calculate_water, cal_water_bill, Select };
